const initialAppState = {
    // Add any other initial global state here if needed
  };
  
  export default function AppStateReducer(state = initialAppState, action = {}) {
    switch (action.type) {
      case "RESET_STATE":
        return initialAppState; // Resets app state to initial values
  
      default:
        return state;
    }
  }
  